<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">订单详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <div class="contentTop">
                    <img src="../../assets/images/success.png" alt="">
                    <span>支付成功</span>
                    <div><span>¥{{ orderInfo.moneyReal }}</span></div>
                    <span>{{ orderInfo.payTime }}</span>
                </div>
                <div class="contentMain">
                    <div class="shopTitle">上林时光（长街店）</div>
                    <div class="leftContent">
                        <span>会员卡号</span>
                        <span>商品总价</span>
                        <span>折扣价格</span>
                        <!-- <span>优惠券</span> -->                        
                        <span>支付方式</span>
                        <span>实付金额</span>
                        <span>积分赠送</span>
                        <span>交易时间</span>
                        <span>订单号</span>
                    </div>
                    <div class="rightContent">
                        <span>SLSG 1083 4791 656</span>
                        <span>¥{{ orderInfo.moneyTotal }}</span>
                        <span>-¥{{ orderInfo.zheKouMinus }}</span>
                        <!-- <span>-¥2.00</span> -->
                        <span v-if="orderInfo.payMethod == 1">卡余额</span>
                        <span v-if="orderInfo.payMethod == 2">现金</span>
                        <span v-if="orderInfo.payMethod == 3">微信</span>
                        <span v-if="orderInfo.payMethod == 4">支付宝</span>
                        <span v-if="orderInfo.payMethod == 5">银行卡</span>
                        <span v-if="orderInfo.payMethod == 6">赊账</span>
                        <span>¥{{ orderInfo.moneyReal }}</span>
                        <span>+{{ orderInfo.giftJiFen }}积分</span>
                        <span>{{ orderInfo.payTime }}</span>
                        <span>{{ orderId }}</span>
                    </div>
                </div>
            </div>
            <div class="listTitle">上林时光（长街店）</div>
            <div class="goodsList">
                <ul>
                    <li class="goods" v-for="(value,index) in orderInfo.products" :key="index">
                        <img src="../../assets/images/head.png" alt="">
                        <span>{{ value.name }}</span>
                        <span>100039</span>
                        <span>X{{ value.count }}</span>
                        <span>¥{{ value.price }}</span>
                    </li>
                </ul>
                <div class="more">
                    展开更多
                    <img class="arrowBottom" src="../../assets/images/arrowBottom.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio, Navbar, TabItem } from "mint-ui";
import axios from "axios";
//import store from "@/vuex/store";
//import { mapState } from "vuex"; 
import global from "../../../static/js/global";
import config from "../../../static/js/config";
export default {
    data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1',
        selectedCardInfo:[],          // 被选中的订单信息 
        orderInfo:[],                 // 订单的详细信息
        orderId:"",                   // 订单号 
    };
    },
    computed: {},
    components: {},
    methods: {
        // 获取订单的详细信息
        getOrderInfo()
        {
            var sid = this.selectedCardInfo.sid;
            this.orderId = this.selectedCardInfo.orderId;
            axios.get(detailOrder+"&uid="+uid+"&sid="+sid+"&orderId="+this.orderId+"&sign="+sign+"&mode="+mode).then(res => {
                console.log('cardInfo',res);
                if (res.data.s == 0)
                {
                    this.orderInfo = res.data;
                }
                else if (res.data.s == 1010)
                {

                }
            })
        }     
    },
    mounted()
    {
        this.selectedCardInfo = this.$store.state.selectedOrderInfo;
        this.getOrderInfo();
    }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
  background-color: #ffffff;  
}
.contentTop{
    width: 9.24rem;
    height: 4.74rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.2);
    margin-left: 0.39rem;
    position: relative;
}
.contentTop :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.39rem;
    left: 3.6rem;
}
.contentTop :nth-child(2){
    font-size: 0.53rem;
    font-weight: 600;
    color: #299EAD;
    position: absolute;
    top: 2.61rem;
    left: 3.45rem;
}
.contentTop :nth-child(3){
    font-size: 0.53rem;
    color: rgba(16, 16, 16, 0.54);
    position: absolute;
    top: 3.53rem;
    left: 3.35rem;
}
.contentTop :nth-child(3) :only-child{
    font-size: 0.53rem;
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: 0rem;
    left: 0.2rem;
}
.contentTop :nth-child(4){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 4.26rem;
    left: 3rem;
}
.contentMain{
    height: 7.84rem;
    width: 100%;
}
.shopTitle{
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
    position: relative;
    top: 0.3rem;
    left: 3.03rem;
}
.leftContent{
    width: 50%;
    height: 100%;
    float: left;
    position: relative;
    top: -0.8rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.rightContent{
    width: 50%;
    height: 100%;
    float: right;
    position: relative;
    top: -0.8rem;
    right: 0rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.leftContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    left: 0.53rem;
}
.leftContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    left: 0.53rem;
}
.leftContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    left: 0.53rem;
}
.leftContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    left: 0.53rem;
}
.leftContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    left: 0.53rem;
}
.leftContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    left: 0.53rem;
}
.leftContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    left: 0.53rem;
}
.leftContent :nth-child(8){
    position: absolute;
    top: 6.65rem;
    left: 0.53rem;
}
.leftContent :nth-child(9){
    position: absolute;
    top: 7.38rem;
    left: 0.53rem;
}
.rightContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    right: 0.37rem;
}
.rightContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    right: 0.37rem;
}
.rightContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    right: 0.37rem;
}
.rightContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    right: 0.37rem;
}
.rightContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    right: 0.37rem;
}
.rightContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    right: 0.37rem;
}
.rightContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    right: 0.37rem;
}
.rightContent :nth-child(8){
    position: absolute;
    top: 6.65rem;
    right: 0.37rem;
}
.rightContent :nth-child(9){
    position: absolute;
    top: 7.38rem;
    right: 0.37rem;
}
.listTitle{
    height: 0.85rem;
    line-height: 0;
    position: relative;
    left: 0.45rem;
    font-size: 0.37rem;
    color: #000000 90%;
}
.goodsList{
    background-color: #fff;
    height: 3.53rem;
    width: 100%;
}
.goods{
    width: 100%;
    height: 2.35rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.2);
    position: relative;
}
.goods :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.26rem;
    left: 0.45rem;
}
.goods :nth-child(2){
    position: absolute;
    top: 0.68rem;
    left: 2.8rem;
}
.goods :nth-child(3){
    position: absolute;
    top: 1.5rem;
    left: 2.8rem;
}
.goods :nth-child(4){
    position: absolute;
    top: 1.5rem;
    left: 4.5rem;
}
.goods :nth-child(5){
    position: absolute;
    top: 1rem;
    right: 0.47rem;
}
.more{
    text-align: center;
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.5);
    position: relative;
    top: 0.25rem;
}
.arrowBottom{
    width: 0.33rem;
    height: 0.33rem;
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/payDetail.vue